'use strict';

var Fuse = require('fuse.js');

var dates = require('util/dates');
var intersectFacets = require('util/intersectFacets');

var get = require('lodash/get');
var find = require('lodash/find');
var extend = require('lodash/extend');
var isArray = require('lodash/isArray');
var sortBy = require('lodash/sortBy');
var groupBy = require('lodash/groupBy');
var forEach = require('lodash/forEach');
var isString = require('lodash/isString');
var intersection = require('lodash/intersection');
var uniqBy = require('lodash/uniqBy');
var values = require('lodash/values');
var filter = require('lodash/filter');

module.exports = ['$filter', function ($filter) {
    var fuseOptions = {
        threshold: 0.3,
        location: 0,
        distance: 500,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: ['prefix', 'title', 'suffix', 'short_description', 'keywords.keyword', 'instructors']
    };

    var fuseArchiveOptions = {
        shouldSort: true,
        threshold: 0.4,
        location: 0,
        minMatchCharLength: 3,
        maxPatternLength: 10,
        distance: 500,
        keys: ['Title']
    };

    var timeSorter = {
        'morning': 0,
        'afternoon': 1,
        'evening': 2
    };

    var daySorter = {
        'monday': 0,
        'tuesday': 1,
        'wednesday': 2,
        'thursday': 3,
        'friday': 4,
        'saturday': 5,
        'sunday': 6,
        'weekday': 7,
        'weekend': 8
    };

    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

    function populateFilter(filter) {
        filter = extend({
            custom: false,
            keywordCondition: false,
            toggle: true,
            visible: true,
            open: false,
            facets: [],
            canClear: false,
            showCount: false
        }, filter);

        if (!('keywordCondition' in filter) || !filter.keywordCondition) {
            filter.keywordCondition = [];
        }

        if (!isArray(filter.keywordCondition)) {
            filter.keywordCondition = [filter.keywordCondition];
        }

        return filter;
    }

    function generateFilters(items, config) {
        // use this as a cache to backtrace the tree of filters
        var filterMap = {};
        var filters = get(config, 'FACET_CONFIG', []);

        // Fill out filters with defaults
        filters = filters.map(populateFilter);

        // Sort by number of conditions
        filters = sortBy(filters, function (filter) {
            return filter.keywordCondition.length;
        });

        // Grab names of categories
        var requiredCategories = filters.map(function (item) {
            return item.category;
        });

        // All facets belonging to all items
        var allKeywords = items.reduce(function (carry, item) {
            return [].concat(carry, item.keywords);
        }, []);

        // Only need what we'll actually be filtering with
        allKeywords = allKeywords.filter(function (item) {
            return requiredCategories.indexOf(item.category) !== -1;
        });

        // Generate filters
        return filters.reduce(function (carry, filter) {
            // Grab available facets for filter
            var facets = allKeywords.filter(function (keyword) {
                return keyword.category === filter.category;
            });

            // Sort :3
            // Time & day has special sort order so we use that
            if (filter.category === 'mm_time_search') {
                facets = facets.sort(function (a, b) {
                    var time1 = a.keyword.toLowerCase();
                    var time2 = b.keyword.toLowerCase();

                    return timeSorter[time1] - timeSorter[time2];
                });
            } else if (filter.category === 'mm_day_search') {
                facets = facets.sort(function (a, b) {
                    var day1 = a.keyword.toLowerCase();
                    var day2 = b.keyword.toLowerCase();

                    return daySorter[day1] - daySorter[day2];
                });
            } else {
                facets = sortBy(facets, function (facet) {
                    return facet.keyword;
                });
            }

            // Group for count ;)
            facets = groupBy(facets, 'keyword');

            // Assign facets
            filter.facets = Object.keys(facets).map(function (facet) {
                var thisFacet = {
                    id: filter.category + '|' + facet,
                    keyword: facet,
                    disabled: false,
                    checked: false,
                    count: facets[facet].length,
                };
                filterMap[filter.category + '|' + facet] = thisFacet;
                return thisFacet;
            });

            // Set find the parent and set these facets as the children
            if (filter.keywordCondition.length && typeof filterMap[filter.keywordCondition[0]] !== 'undefined') {
                filterMap[filter.keywordCondition[0]].children = filter.facets;
            }

            carry.push(filter);

            return carry;
        }, [] );
    }

    function updateFacets(filters) {
        var appliedFacets = filters.reduce(function (carry, filter) {
            var facets = filter.facets.filter(function (facet) {
                return facet.checked;
            });

            facets = facets.map(function (facet) {
                return facet.id;
            });

            return [].concat(carry, facets);
        }, []);

        return filters.map(function (filter) {
            if (!filter.keywordCondition.length) {
                return filter;
            }

            var visible = intersection(appliedFacets, filter.keywordCondition);

            if (visible.length) {
                filter.visible = true;
                filter.open = true;
            } else {
                filter.facets = filter.facets.map(function (facet) {
                    facet.checked = false;

                    return facet;
                });

                filter.visible = false;
            }

            return filter;
        });
    }

    function updateFilters(params) {
        // Grab a list of applied filters
        var appliedCategories = params.facets.map(function (facet) {
            return facet.category;
        });

        // Begin with full list
        var filteredItems = params.items.filter(item=>{
            return item.prices.length > 0;
        });

        if (params.selectedShow > 0){
            filteredItems = filter(filteredItems, event => {
                return event.prod_season_no === params.selectedShow;
            })
        }

        var priceRange = params.price;
        filteredItems = filterByPriceRangeFlexible(priceRange, filteredItems);

        // Grab keyword
        var searchKeyword = stripStopWords(params.keywords);

        // Filter by keywords first if possible
        if (searchKeyword.length) {
            var fuse = new Fuse(params.items, fuseOptions);

            filteredItems = fuse.search(searchKeyword);
        }        
        
        // Filter by start range (if exists)
        if (params.range.start) {
            var startDate = params.range.start.startOf('day');            
            filteredItems = filteredItems.filter(function (item) {
                return item.start_date_moment.isSameOrAfter(startDate);
            });
        }
        
        // Filter by end range (if exists)
        if (params.range.end) {
            var endDate = params.range.end.endOf('day');
            filteredItems = filteredItems.filter(function (item) {
                return item.end_date_moment.isSameOrBefore(endDate);
            });
        }

        // Re-work filters
        return params.filters.map(function (filter) {

            // Can filter be cleared?
            filter.canClear = appliedCategories.indexOf(filter.category) !== -1;

            if (filter.keywordCondition.length) {
                return filter;
            }

            // Open the grop if its closed but in use
            if (filter.canClear && !filter.open) {
                filter.open = true;
            }

            // Re-work facets
            filter.facets = filter.facets.map(function (facet) {
                // No need to process if already checked
                if (facet.checked) {
                    return facet;
                }

                // Selected facets + current facet
                var potentialFacets = [].concat(params.facets, {
                    category: filter.category,
                    keyword: facet.keyword
                });

                // Group by name for ease of comparision
                potentialFacets = groupBy(potentialFacets, 'category');

                // Start off with (potential) keyword filtered items
                var potentialResults = filteredItems;

                // Apply filters
                forEach(potentialFacets, function (facets) {
                    // Potential results IF current facet is applied
                    potentialResults = potentialResults.filter(function (item) {
                        return intersectFacets(item.keywords, facets).length;
                    });
                });

                // Grab facets off results
                potentialFacets = potentialResults.reduce(function (carry, item) {
                    return [].concat(carry, item.keywords);
                }, []);

                // But we only want the current facet
                potentialFacets = potentialFacets.filter(function (item) {
                    return item.category === filter.category && item.keyword === facet.keyword;
                });

                // Update to the "would-be" total
                facet.count = potentialFacets.length;

                // Will the future state mean empty results?
                facet.disabled = !facet.count;

                // Return!
                return facet;
            });

            // Return!
            return filter;
        });
    }

    

    function getTopLevelKeyword(facet, filters) {
        if (!facet.conditions.length) {
            return [facet.keyword];
        }

        var topLevelKeywords = [];

        facet.conditions.forEach(function (condition) {
            filters.forEach(function (filter) {
                filter.facets.forEach(function (item) {
                    if (item.id === condition && filter.keywordCondition) {
                        var itemClone = extend({
                            conditions: filter.keywordCondition,
                            category: filter.category
                        }, item);

                        topLevelKeywords = [].concat(
                            topLevelKeywords,
                            getTopLevelKeyword(itemClone, filters)
                        );
                    }
                });
            });
        });

        return topLevelKeywords;
    }

    function applyFilters(params) {
        // Start off with current all items (non filtered)
        var filteredItems = params.items;

        if (params.selectedShow > 0){
            filteredItems = filter(filteredItems, event => {
                return event.prod_season_no === params.selectedShow;
            });
        }


        var priceRange = params.price;

        filteredItems = filterByPriceRangeFlexible(priceRange, filteredItems);

        // Grab keyword
        var keyword = stripStopWords(params.keyword);

        // Apply keyword search
        if (keyword.length) {
            fuseOptions = (params.isArchive) ? fuseArchiveOptions: fuseOptions;
            var fuse = new Fuse(filteredItems, fuseOptions);
            filteredItems = fuse.search(keyword);
        }

        // Grab range
        var range = params.range;

        if (params.isArchive) {
            if (range.start) {
                var archiveStartDate = dates.momentObj(range.start,'MMM D, Y').startOf('day');
                filteredItems = filteredItems.filter(function (item) {
                    // If this is a performance then check the single start date
                    return item.compareDate.isSameOrAfter(archiveStartDate);

                });
            }

            if (range.end) {
                var archiveEndDate = dates.momentObj(range.end,'MMM D, Y').endOf('day');
                filteredItems = filteredItems.filter(function (item) {
                    return item.compareDate.isSameOrBefore(archiveEndDate);
                });
            }
        } else {

            if (range.start) {
                var startDate = dates.momentObj(range.start,'MMM D, Y').startOf('day');
                filteredItems = filteredItems.filter(function (item) {
                    // If this is a performance then check the single start date
                    if (typeof item.performances === 'undefined') {
                        return item.start_date_moment.isSameOrAfter(startDate);
                    }
                    // If this is a production then check against each the performance start dates
                    return item.performances.some(function(perf){ return perf.perf_dt_moment.isSameOrAfter(startDate); });
                });
            }

            if (range.end) {
                var endDate = dates.momentObj(range.end,'MMM D, Y').endOf('day');
                filteredItems = filteredItems.filter(function (item) {
                    // If this is a performance then check the single start date
                    if (typeof item.performances === 'undefined') {
                        return item.end_date_moment.isSameOrBefore(endDate);
                    }
                    // If this is a production then check against each the performance start dates

                    if (range.start) {
                        // if there is a start date, include that in the check so we only get
                        // events with performances in between the two dates
                        return item.performances.some(function(perf){ return perf.perf_dt_moment.isSameOrAfter(dates.momentObj(range.start,'MMM D, Y').startOf('day')) && perf.perf_dt_moment.isSameOrBefore(endDate); });
                    }
                    return item.performances.some(function(perf){ return perf.perf_dt_moment.isSameOrBefore(endDate); });
                });
            }
        }


        // To keep track of applied filters
        var appliedFacets = [];

        // Level 2 facets
        var specialFacets = [];

        // Loop through filters
        params.filters.forEach(function (filter) {
            // Grab selected facets
            var selectedFacets = filter.facets.filter(function (facet) {
                return facet.checked && !facet.disabled;
            });

            // Skip if this filter not being used
            if (!selectedFacets.length) {
                return false;
            }

            // Grab a nice set that can be used to compare
            selectedFacets = selectedFacets.map(function (facet) {
                return {
                    children: facet.children || [],
                    conditions: filter.keywordCondition,
                    category: filter.category,
                    keyword: facet.keyword
                };
            });

            if (filter.keywordCondition.length) {
                specialFacets = [].concat(specialFacets, selectedFacets);
                return false;
            }

            // Keep track of applied facet
            appliedFacets = [].concat(appliedFacets, selectedFacets);

            // Apply facets to item set
            filteredItems = filteredItems.filter(function (item) {
                // Match filtered facets with item facets
                return intersectFacets(item.keywords, selectedFacets).length;
            });
        });

        if (specialFacets.length) {
            // Make sure there's top level keywords
            specialFacets = specialFacets.map(function (facet) {
                var parentKeywords = getTopLevelKeyword(facet, params.filters);
                facet.parentKeywords = parentKeywords.join('+');
                return facet;
            });
            specialFacets.forEach(function (facet) {
                facet.childSelected = !!find(facet.children, 'checked');
            });

            var specialFacetsWithNoSelectedChildren = specialFacets.filter(function (facet) {
                return !facet.childSelected;
            });

            // Group by top level keywords (but not ones where a child is selected)
            var groupedSpecialFacets = groupBy(specialFacetsWithNoSelectedChildren, 'parentKeywords');

            var specialFiltered = [].concat.apply([],values(groupedSpecialFacets)
                .map(function(facets){
                    var facetItems = facets.map(function(facet) {
                        return filteredItems.filter(function (item) {
                            // Match filtered facets with item facets
                            return intersectFacets(item.keywords, [facet]).length;
                        });
                    });
                    return [].concat.apply([], facetItems);
                }));

            filteredItems = uniqBy(specialFiltered, 'id');
        }

        // Also grab applied categories
        var appliedCategories = appliedFacets.map(function (facet) {
            return facet.category;
        });

        return {
            items: filteredItems,
            facets: [].concat(appliedFacets, specialFacets),
            categories: appliedCategories
        };
    }

    function stripStopWords(string) {
        if (!string || !isString(string)) {
            return '';
        }

        // Remove stop words from string and return trimmed result
        return $filter('stripStopWords')(string).trim();
    }

    function parseDate(date) {
        var tokens = /^(\D{3}) (\d{1,2}), (\d{4})$/.exec(date);
        return tokens && dates.moment(new Date(tokens[3], months.indexOf(tokens[1]), tokens[2]));
    }

    function clearFacets(params) {
        return params.filters.map(function (filter) {
            if (filter.category !== params.category) {
                return filter;
            }

            var deselectChildren = function(facet){
                if (typeof facet.children !== 'undefined') {
                    facet.children.forEach(deselectChildren);
                }
                facet.checked = false;
            };

            filter.facets = filter.facets.map(function (facet) {
                //recursively deselect any children
                deselectChildren(facet);
                return facet;
            });

            return filter;
        });
    }

    function filterByPriceRangeFlexible(priceRange, performances) {

        let filtered = performances.filter(performance => {

            let inrange = false;

            // check to see if the max price of the performance is greater than 150.
            // if it is then set in range to true and we don't need to check for anything else.

            if(priceRange.max === 150){
                if (performance.max_price >= priceRange.max){
                    return true;
                }
            }

            // if the max range isn't greater than 150 then we need to filter by the ticket prices.
            if (!inrange) {

                for (let index = 0; index < performance.prices_collection.length; index++) {
                    const price = performance.prices_collection[index];
                    // check to see if an individual ticket price is withing range of the price filter min/max
                    if (price >= priceRange.min && price <= priceRange.max) {
                        return true;
                    }
                }
            }

            return inrange;

        });

        return filtered;
    }


    return {
        fuseOptions: fuseOptions,
        generateFilters: generateFilters,
        updateFacets: updateFacets,
        updateFilters: updateFilters,
        applyFilters: applyFilters,
        clearFacets: clearFacets,
        filterByPriceRangeFlexible: filterByPriceRangeFlexible
    };
}];



// WEBPACK FOOTER //
// ./widgets/services/FTFServices/FacetService.js